import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Suspense } from 'react';
import { NoAuthRoute, noProtectRoutes } from './NoAuthRoute';
import { AuthRoute, protectedRoutes } from './AuthRoute';

import { AuthProvider } from '@contexts/auth.context';

export const Router = () => {
	return (
		<BrowserRouter>
			<AuthProvider>
				<Suspense fallback={''}>
					<Routes>
						{noProtectRoutes?.map(route => (
							<Route
								key={Math.random()}
								{...{ ...route }}
								element={
									<NoAuthRoute {...{ ...route }}>
										<>{route.element}</>
									</NoAuthRoute>
								}
							/>
						))}
						{protectedRoutes?.map(route => (
							<Route
								key={Math.random()}
								{...{ ...route }}
								element={
									<AuthRoute {...{ ...route }}>
										<>{route.element}</>
									</AuthRoute>
								}
							/>
						))}
						<Route path="*" element={<h1>Not found</h1>} />
					</Routes>
				</Suspense>
			</AuthProvider>
		</BrowserRouter>
	);
};
